import {get} from "lodash";
import {createSelector} from "reselect";
import {parseRequestState} from "modules/utils";
import {IStore} from "modules/types/store";

export const getGameState = (store: IStore) => store.game;

export const getActiveStep = createSelector(getGameState, ({step}) => step);

export const getErrors = createSelector(getGameState, ({errors}) => errors);

export const getAnswers = createSelector(getGameState, ({answers}) => answers);

export const getQuestionAnswerById = createSelector(getAnswers, (data) => (id: number) => {
	const question = data.find(({questionId}) => questionId === id);
	return get(question, "optionId", 0);
});

export const getIsFriendlyCountryState = createSelector(
	getGameState,
	({isFriendlyCountry}) => isFriendlyCountry
);

export const getAnchorId = createSelector(getGameState, ({anchorId}) => anchorId);

export const getAnswersRequestState = createSelector(getGameState, ({requestState}) =>
	parseRequestState(requestState)
);

export const getSavedOptions = createSelector(getGameState, ({savedOptions}) => savedOptions);

export const getIsEditMode = createSelector(getSavedOptions, (savedOptions) =>
	Boolean(savedOptions.length)
);

export const getSavePicksRequestStates = createSelector(getGameState, ({saveRequestState}) =>
	parseRequestState(saveRequestState)
);
